export const cacheKeys = {
  getInquiryMessages: (params) =>
    params
      ? ['getInquiryMessages', params]
      : ['getInquiryMessages'],
};
